export default {
    api: {
        baseUrl: process.env.VUE_APP_API_URL,
        baseUrlContextPattern: process.env.VUE_APP_API_URL_CONTEXT_PATTERN,
    }
}
